<template>
  <div>
    <div class="modal-body d-flex flex-column gap-20">
        <div class="d-flex flex-column gap-5">
            <h2>{{ 'Your input matters!' | trans }}</h2>
            <p>{{ 'Share your thoughts, suggestions, or experiences using our services. Your feedback helps us improve. Thank you for being a part of our journey!' | trans }}</p>
        </div>
        <div class="d-flex flex-column gap-10">
            <strong>{{ 'How would you rate us?' | trans }}</strong>
            <p v-if="feedbackManager?.showError" class="text-danger m-0">{{ 'Please enter a rating before submitting your feedback!' | trans }}</p>
            <div class="d-flex gap-15">
              <label class="radio-inline">
                  <input type="radio" v-model="rating" value="5" />
                  {{ 'Great' | trans }}
              </label>
              <label class="radio-inline">
                  <input type="radio" v-model="rating" value="4" />
                  {{ 'Good' | trans }}
              </label>
              <label class="radio-inline">
                  <input type="radio" v-model="rating" value="3" />
                  {{ 'Medium' | trans }}
              </label>
              <label class="radio-inline">
                  <input type="radio" v-model="rating" value="2" />
                  {{ 'Bad' | trans }}
              </label>
              <label class="radio-inline">
                  <input type="radio" v-model="rating" value="1" />
                  {{ 'Worse' | trans }}
              </label>
            </div>
        </div>
        <TextArea
          v-model="message"
          :border-class="'br-4'"
          :label="placeholder"
          :max-characters="4000"
          :rows="'4'"
          :value="creatorStudio.settings.prompt"
          :aiCustom="true"
          class="w-100 feedback-text-area"
          name="prompt"
          type="text"
        ></TextArea>
    </div>
    <div class="modal-footer">
      <button class="btn close-btn" @click.prevent="close">
        <i class="fa fa-times mr-1"></i><strong>{{ 'Cancel' | trans }}</strong>
      </button>
      <button class="btn feedback-submit-btn" @click.stop="submitFeeback">
        <i v-if="!feedbackManager?.loading" class="fa fa-chevron-right"></i>
        <i v-if="feedbackManager?.loading" class="fa fa-spin btn-loading-animation"></i>
        <strong>
          {{ 'Submit' | trans }}
        </strong>
      </button>
    </div>
  </div>
</template>
<script>
import store from '../../../mixins/store.mixin';
import currentJob from '../../../mixins/current_job.mixin';
import FeedbackManager from "../../../manager/FeedbackManager";
import { translate } from '../../../../../../../helper/translate';
import TextArea from '../../../../form/TextArea.vue';

export default {
  name: 'FeedbackFormModal',
  props: {},
  components: { TextArea },
  mixins: [store, currentJob],
  data() {
    return {
      message: '',
      rating: null,
      feedbackManager: FeedbackManager,
      placeholder: translate('Something you want to tell us? (optional)')
    };
  },
  created: function () {},
  methods: {
    submitFeeback() {
      this.feedbackManager?.submitFeedback(this.currentJob, this.rating, this.message)
    },
    close() {
      $('#FeedbackModal').modal('hide');
    },
  },
  computed: {},
};
</script>
